import { CustomerEntityType } from 'types/customers'
import { ActionIds, WalletType } from 'types/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export interface CustomerDetails {
  name: string
  type: CustomerEntityType
  details: Record<string, string>
}

export interface CustomerDepositDetails {
  name: string
  address: string
}

export const ModalStep = {
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  CONFIRMATION: 'CONFIRMATION',
} as const

export type ModalStep = (typeof ModalStep)[keyof typeof ModalStep]

export interface CustomerWalletPageParams {
  customerReference?: string
  customerWalletId?: string
}

export const TransferStep = {
  FORM: 'FORM',
  CONFIRMATION: 'CONFIRMATION',
  COMPLETE: 'COMPLETE',
} as const

export type TransferStep = (typeof TransferStep)[keyof typeof TransferStep]

export interface MoveCustomerFundsSchemaProps {
  selectedWallet: string
  type: string
  receivingWallet: string
  amount: string
  paymentReference: string
  destinationWalletName?: string
  destinationCustomerName?: string
}

export interface MovePayload {
  walletTransferType?: WalletTransferType
  customerReference?: string
  destinationWallet?: string
  amount?: string
  paymentReference?: string
  destinationWalletName?: string
  destinationCustomerName?: string
}

export interface GetTransferPayloadProps {
  destinationWalletId?: string
  transferAmount?: string
  paymentReference?: string
}

export interface WalletActionProps {
  action: ActionIds
  wallet: WalletType
}

export interface OrchestratedWalletProfile {
  reference: string
  paymentMethods: string[]
}

export interface CurrencyProfileMapping {
  isCryptoProfile: boolean
  profiles: OrchestratedWalletProfile[]
}

export interface WalletProfileMapping {
  [property: string]: CurrencyProfileMapping
}
